import * as React from 'react';
import styled, {css} from 'styled-components';
import SidebarContext from '../SidebarContext';
import {Theme} from 'stores/AppStore';

const Container = styled.button<{
  isToggle?: boolean;
}>`
  position: absolute;
  top: 45px;
  right: 0;
  height: 76px;
  width: 29px;
  
  &:before {
    content: "";

    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 8px;
    
    margin: auto;
    background-size: cover;
    transform: rotate(${({isToggle}) => !isToggle && '180deg'});
    background-position: center;
    display: flex;
    height: 12px;
    width: 6px;

    ${({theme}) => theme.name === Theme.Dark && css`
      background-image: url("data:image/svg+xml,%3Csvg width='6' height='12' viewBox='0 0 6 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5 1.5013L1 5.83464L5 10.168' stroke='white' stroke-opacity='0.4' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
    `};

    ${({theme}) => theme.name === Theme.Light && css`
      background-image: url("data:image/svg+xml,%3Csvg width='6' height='12' viewBox='0 0 6 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5 1.5013L1 5.83464L5 10.168' stroke='black' stroke-opacity='0.4' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
    `};
  }

  ${({theme}) => theme.name === Theme.Dark && css`
    background-image: url("data:image/svg+xml,%3Csvg width='29' height='77' viewBox='0 0 29 77' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M29 0.172641V76.3161C29 69.6887 23.4705 64.6354 17.173 62.5705C5.82539 58.8497 6.0612e-05 49.584 0 38.7018C-6.09607e-05 27.7568 5.62322 17.902 17.1854 13.9756C23.4609 11.8445 29 6.80006 29 0.172641Z' fill='%23232323'/%3E%3C/svg%3E%0A");
  `};

  ${({theme}) => theme.name === Theme.Light && css`
    background-image: url("data:image/svg+xml,%3Csvg width='29' height='77' viewBox='0 0 29 77' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M29 0.172641V76.3161C29 69.6887 23.4705 64.6354 17.173 62.5705C5.82539 58.8497 6.0612e-05 49.584 0 38.7018C-6.09607e-05 27.7568 5.62322 17.902 17.1854 13.9756C23.4609 11.8445 29 6.80006 29 0.172641Z' fill='%23F2F4F9'/%3E%3C/svg%3E%0A");
  `};
`;

/**
 * This function renders the sidebar state switch.
 * @param {React.ButtonHTMLAttributes<HTMLButtonElement>} props
 * @return {React.ReactElement<React.ButtonHTMLAttributes<HTMLButtonElement>>}
 * @constructor
 */
export default function ToggleButton(
    props: React.ButtonHTMLAttributes<HTMLButtonElement>,
): React.ReactElement<React.ButtonHTMLAttributes<HTMLButtonElement>> {
  const {isToggle, setToggle} = React.useContext(SidebarContext);

  /**
   * This click event handler.
   */
  function handleClick(): void {
    setToggle && setToggle(!isToggle);
  }

  return (
    <Container
      {...props}
      type="button"
      isToggle={isToggle}
      onClick={handleClick}
    />
  );
}
